<template>
<div class="chapter">
<div class="inner_page">
<section class="ident dedicaces" epub:type="dedication" id="dedicaces" role="doc-dedication">
<p class="dedi"><span>To Kathryn Helmers, my agent, who kept asking,<br/>
    “What if?” until if came true.</span></p>
</section>
</div>
</div>
</template>
<script>

export default {
  name: 'chapter',
  data() {
    return {}
    },
      components: {
    }
  }
</script>



// WEBPACK FOOTER //
// ident13.vue?7d766d20